import { render, staticRenderFns } from "./SpendBackStepAccounts.vue?vue&type=template&id=6d85c36f"
import script from "./SpendBackStepAccounts.vue?vue&type=script&lang=js"
export * from "./SpendBackStepAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports